import React from 'react';
import OffersNotFound from '@/features/oferta/components/OffersNotFound';
import { useTranslations } from 'next-intl';
import { GridContainer } from './OffersList.styles';
import CardOffer from '@/features/oferta/components/CardOffer/CardOffer';

export interface OffersListProps {
  offers?: OffersType;
}

const OffersList = ({ offers }: OffersListProps) => {
  const t = useTranslations('Oferta');
  if (!offers || !offers.length) {
    return <OffersNotFound />;
  }
  return (
    <GridContainer>
      {offers.map((offer, index) => (
        <CardOffer offer={offer} key={`offer-${index}`} />
      ))}
    </GridContainer>
  );
};

export default OffersList;
